export default __webpack_public_path__ + "9925991adaade503a5e12c96db9c2cac.png";